var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMealPlanNotSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0855 2.19055H11.7712C7.43425 2.19055 5.26578 2.19055 3.91848 3.53786C2.57117 4.88517 2.57117 7.05363 2.57117 11.3906V11.6096C2.57117 15.9465 2.57117 18.115 3.91848 19.4623C5.26578 20.8096 7.43424 20.8096 11.7712 20.8096H13.0855C17.4224 20.8096 19.5908 20.8096 20.9381 19.4623C22.2855 18.115 22.2855 15.9465 22.2855 11.6096V11.3906C22.2855 7.05363 22.2855 4.88517 20.9381 3.53786C19.5908 2.19055 17.4224 2.19055 13.0855 2.19055Z",
    fill: "#A0A0A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.57117 7.66663H22.2855",
    stroke: "white",
    strokeWidth: 1.725,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49963 1.09534V3.57788M17.3568 1.09534V3.57788",
    stroke: "#A0A0A0",
    strokeWidth: 1.725,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.42847,
    cy: 11.5,
    r: 0.5,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4285,
    cy: 11.5,
    r: 0.5,
    fill: "#D9D9D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.4285,
    cy: 11.5,
    r: 0.5,
    fill: "#D9D9D9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4285,
    cy: 15.5,
    r: 0.5,
    fill: "#D9D9D9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.42847,
    cy: 15.5,
    r: 0.5,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMealPlanNotSelected);
export default __webpack_public_path__ + "static/media/mealPlanNotSelected.f29d9da8ec1e845eb3ba973322ef2125.svg";
export { ForwardRef as ReactComponent };